import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from '@g99-product-web-ui/shared-util-lib';
import { Observable } from 'rxjs';

import { HttpService } from '../../core/http-service/http.service';

@Injectable({
  providedIn: 'root',
})
export class SharedQuestionarieService {
  constructor(private _httpService: HttpService) {}

  public fetchQuestionnaries(): Observable<any[]> {
    const url = API_ENDPOINTS.FORM_BUILDER.getQuestionnaireV1;
    return this._httpService.get<any[]>(url);
  }

  public deleteQuestionnarie(id: number) {
    const url = API_ENDPOINTS.FORM_BUILDER.deleteForm(id);
    return this._httpService.delete(url);
  }
}
